import { useEffect, useRef } from 'react'
import { pageview } from '../ga4'

export default function useGA4Pageview(page: string, condition = true) {
  const argsRef = useRef({ page, condition })
  useEffect(() => {
    if (argsRef.current.condition) {
      pageview(argsRef.current.page)
    }
  }, [])
}
